module.exports = __webpack_public_path__ + "ee7e7fdca8afde42837a1848b9df71c0.png";